import * as THREE from 'three';
export class Cube {
    constructor(cubeIndex, x, y, z) {
        this.delay = 0;
        this.durationOffset = 0;
        this.visible = true;
        this.interact = 0;
        this.cubeIndex = cubeIndex;
        this.position = new THREE.Vector3(x, y, z);
        this.rotation = new THREE.Vector3();
        this.scale = new THREE.Vector3(1, 1, 1);
        this.grid;
        this.cue = new THREE.Vector3();
        this.cueRot = new THREE.Vector3();
        this.addRot = new THREE.Vector3();
        this.cueScale = new THREE.Vector3();
        this.resetCueScale();
        this.resetHsl();
    }
    setCueWithGridOffset(x, y, z) {
        this.cue.set(x + this.grid.x, y + this.grid.y, z + this.grid.z);
    }
    setRanCuePos(x, y, z) {
        this.cue.set(this.ranHalf(x) + this.cue.x, this.ranHalf(y) + this.cue.y, this.ranHalf(z) + this.cue.z);
    }
    setRanCueScale(x, y, z) {
        this.cueScale.set(this.ranHalf(x) + this.cueScale.x, this.ranHalf(y) + this.cueScale.y, this.ranHalf(z) + this.cueScale.z);
    }
    setRanCueRot(x, y, z) {
        this.cueRot.set(this.ranHalf(x) + this.cueRot.x, this.ranHalf(y) + this.cueRot.y, this.ranHalf(z) + this.cueRot.z);
    }
    resetCueRotation() {
        this.cueRot.x = this.cueRot.y = this.cueRot.z = 0;
    }
    resetCueScale() {
        this.cueScale.x = this.cueScale.y = this.cueScale.z = 1.021;
    }
    resetCueGridOffset(x, y, z) {
        this.cue.x = this.grid.x + x;
        this.cue.y = this.grid.y + y;
        this.cue.z = this.grid.z + z;
    }
    ranHalf(v) {
        return (Math.random() * v) - (v * .5);
    }
    resetHsl() {
        this.hslFront = new THREE.Vector3(1, 0, 1);
        this.hslBack = new THREE.Vector3(1, 0, 1);
    }
}
